<template lang="html">
  <template v-if="!loadingState">
    <innerHeader/>
    <div class="commonmargin">
      <div class="row justify-content-center">
        <div class="col-12 col-lg-10 col-md-10 col-xl-10 mx-auto" >
          <div class="row " >
            <div class="col-md-5  mobileorder1 p-4 rounded">
              <button class="backbuttonTop max-w-md mt-0 mb-3" @click="revisitSingleQuote()" v-if="!isShow && !['payment'].includes(nextRef)"><img src="/images/backarrow.svg" width="12px" class="selectrtosvg" />BACK TO QUOTES</button>
              <productDetailsHeader/>
            </div>
            <div class="col-12 col-lg-7 col-md-7 col-xl-7 text-center kycform mobileorder2 pt-0">
              <div class="kyc_input-content rounded">
                <img src="/images/kyc.gif" />
                <h1 class="headings my-3">Complete Your KYC</h1>
                <div class="row justify-content-center">
                  <div class="col-12 col-lg-12 col-md-12 col-xl-12">
                    <div class="card">
                      <div class="d-flex w-100">
                        <div class="d-flex flex-column w-100 mr-10">
                          <label class="headinglabel mb-1"> Full Name <span style="color:#f00">*</span></label>
                          <input type="text" class="form-control p-2" placeholder="Enter Full Name" v-model="fullName" />
                          <span class="text-danger errormsg mt-2">{{errorMsg["fullName"]}}</span>
                        </div>
                        <div class="d-flex flex-column w-100">
                          <label class="headinglabel mb-1"> Gender <span style="color:#f00">*</span></label>
                          <select name="gender" id="gender" class="form-control p-2" v-model="gender">
                            <option value="" disabled selected>Gender</option>
                            <option value="M">Male</option>
                            <option value="F">Female</option>
                          </select>
                          <span class="text-danger errormsg mt-2">{{errorMsg["gender"]}}</span>
                        </div>
                      </div>
                      <div class="d-flex w-100">
                        <div class="d-flex flex-column w-100 mr-10">
                          <label class="headinglabel mb-1" >{{userType=='corporate' ? 'Company ' : ''}}PAN Number <span style="color:#f00">*</span></label>
                          <input type="text" maxlength="10" class="form-control p-2" @input="doUppercase()" placeholder="PAN Number" v-model="panNumber" @keypress="restrictSpecialChars"/>
                          <span class="text-danger errormsg mt-2">{{errorMsg["pan_number"]}}</span>
                        </div>
                        <div class="d-flex flex-column w-100">
                          <label class="headinglabel  mt-3 mb-1" >{{userType=='corporate' ? 'Date of Establishment ' : 'Date of Birth '}}<span style="color:#f00">*</span></label>
                          <div  class="position-relative">
                            <DateField id="kyc-date" name="dob" :max="getMaxDate" v-model="dateOfBirth" @onInput="doUppercase()" />
                            <div v-if="errorMsg['dob']" class="d-flex mt-2">
                              <span class="text-danger errormsg">{{errorMsg["dob"]}}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="d-flex w-100">
                        <div class="d-flex flex-column w-50 mr-10">
                          <label class="headinglabel mb-1" >Mobile Number <span style="color:#f00">*</span></label>
                          <input
                            type="tel"
                            inputmode="numeric"
                            maxlength="10"
                            autocomplete="tel"
                            class="form-control p-2"
                            placeholder="Mobile Number"
                            v-model="mobileNumber"
                            @input="onMobileInput"
                          />
                          <span class="text-danger errormsg mt-2">{{errorMsg["mobile_number"]}}</span>
                        </div>
                        <div class="d-flex flex-column w-50 mr-10" v-if="kycStatus?.toLowerCase() === 'verifyotp' && isUploadDocRequired">
                          <label class="headinglabel mb-1" > OTP <span style="color:#f00">*</span></label>
                          <input
                            type="tel"
                            inputmode="numeric"
                            maxlength="6"
                            class="form-control p-2"
                            placeholder="Enter OTP"
                            v-model="otp"
                            @input="onOtpInput"
                          />
                          <span class="text-danger errormsg mt-2">{{errorMsg["otp"]}}</span>
                        </div>
                      </div>
                      <div v-if="isUploadDocRequired" class="mt-0">
                        <p class="successClass px-2 py-1 rounded h4 mt-0">{{ getSuccessMessage }}</p>
                        <div class="d-flex align-items-center gap-2 w-100">
                          <button class="backbutton w-100" @click="fetchKyc()" :disabled="handleDisableCkyc">Fetch KYC</button>
                          <button class="continueWithProposal btn w-100" @click="proceedToDocUpload()" :disabled="handleDisableCkyc" v-if="isUploadDocRequired && isOvd && kycMode === 'POST'">Proceed With Document Upload</button>
                          <button class="continueWithProposal btn w-100" @click="continueWithProposal()" v-else-if="changeInCkycFields">Continue with Proposal</button>
                        </div>
                      </div>
                      <div v-else class="mt-0">
                        <div v-if="kycIsSucceed" class="d-flex align-items-center justify-content-between py-1">
                          <p class="success_ckyc_msg px-2 h4">Your KYC has been successfully verified.</p>
                          <p class="success_ckyc_msg px-2 h4">{{timeRemain}}s</p>
                        </div>
                        <button class="commonButton mt-3" @click="fetchKyc()" :disabled="handleDisableCkyc" v-if="!kycIsSucceed">Fetch KYC</button>
                      </div>
                    </div>
                    <div class="mt-3 text-left">
                      <ul class="custom-list">
                        <li>
                          By Clicking on <strong>Fetch KYC</strong> button:
                        </li>
                        <li>
                          I/We authorize the Company to share information pertaining to my / our proposal including the medical records of the Insured / Proposer for the sole purpose of Service Delivery with our empaneled provider.
                        </li>
                        <ul class="custom-list inner-list">
                          <li>
                            I, hereby provide my consent to <strong>{{ selectedPlan?.insuranceAndProducts?.insuranceCompanyName }}</strong> to share my personal information with relevant third-party agencies for the purpose of updating KYC details in my existing policies. I understand and acknowledge that by providing consent:
                          </li>
                          <li>
                            I authorize <strong>{{ selectedPlan?.insuranceAndProducts?.insuranceCompanyName }}</strong> to disclose the necessary personal information required for updating KYC details.
                          </li>
                          <li>
                            I acknowledge that the information shared may include my name, address, age, contact details, identification documents, and other information as required under KYC compliance.
                          </li>
                          <li>
                            I understand that the purpose of sharing this information is solely for updating KYC details in my policies for the purpose of servicing. My personal information shall be handled in accordance with applicable data protection laws and regulations.
                          </li>
                          <li>
                            I hereby consent to <strong>{{ selectedPlan?.insuranceAndProducts?.insuranceCompanyName }}</strong> for the processing of my KYC record/information from CKYCRR, for the purpose of KYC. My consent is given freely, specifically for this purpose, and is INFORMED, UNCONDITIONAL, and UNAMBIGUOUS. By providing this consent, I agree that the company may collect and use only the necessary personal data required for the specified purpose.
                          </li>
                        </ul>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Disclaimer :page="'CKYC'"/>
    </div>
  </template>
<template v-else>
    <pageLoader :msg="loadingMsg" />
  </template>
  <!-- Payment In Progress Dialog -->
  <PaymentInProgressDialog 
    v-model:visible="showPaymentInProgressModal"
    :message="paymentInProgressMessage"
    @handleContinue="handlePaymentInProgressContinue"
    @handleCancel="handlePaymentInProgressCancel" />
  <!-- END: Payment In Progress Dialog -->
</template>
<script>
import innerHeader from "@/components/header/innerHeader.vue";
import pageLoader from "@/components/pageLoaders/pageLoader.vue";
import { getDistributer } from "@/mixins/common";
import productDetailsHeader from "../productDetailsHeader/ProductDetailsHeader.vue";
import moment from 'moment';
import Disclaimer from "@/components/uiResuable/Disclaimer.vue"
import DateField from '@/components/formComponents/DateField.vue';
import backendApi from '@/apis/axios-backend';
import PaymentInProgressDialog from '../common/PaymentInProgressDialog.vue';
import { shouldSkipGodigitKycOvd } from '@/utils/godigitKycOvdSkip';
import { navigateToPaymentStatusOutcome } from '@/lib/payment/navigate-payment-outcome';
import { PAYMENT_STATUS_OUTCOME_SUCCESS } from '@/lib/payment/payment-status-constants';

export default {
  components: {
    innerHeader,
    pageLoader,
    productDetailsHeader,
    Disclaimer,
    DateField,
    PaymentInProgressDialog
  },
  mixins: [getDistributer],
  data() {
    return {
      // userData:{},
      distributorID: "",
      loadingState: false,
      loadingMsg: "",
      msg: [],
      panNumber: sessionStorage.getItem("kycdata") && JSON.parse(sessionStorage.getItem("kycdata")).panNumber ? JSON.parse(sessionStorage.getItem("kycdata")).panNumber : "",
      dateOfBirth: sessionStorage.getItem("kycdata") && JSON.parse(sessionStorage.getItem("kycdata")).dateOfBirth ? JSON.parse(sessionStorage.getItem("kycdata")).dateOfBirth : "",
      quoteResponseId: "",
      kycResponse: "",
      kycStatus: "",
      kycRedirectUrl: "",
      userType: "",
      errorMsg: [],
      journey_id: sessionStorage.getItem("journey_id")
        ? JSON.parse(sessionStorage.getItem("journey_id"))
        : "",
      selectedPlan: {},
      isOvd: false,
      errorMessage: "",
      kycIsSucceed: false,
      timeRemain: 3,
      singleQuote: JSON.parse(sessionStorage.getItem("quoteSingleData")),
      isUploadDocRequired: false,
      handleDisableCkyc: false,
      rmData: null,
      apiReqData: "",
      nextRef: "",
      fullName: "",
      gender: "",
      otp: '',
      referenceId: '',
      kycMode: '',
      currentKycStatus: '',
      manuRequirementNo: '',
      finalPayload: {},
      mobileNumber: '',
      // Payment In Progress Modal
      showPaymentInProgressModal: false,
      paymentInProgressMessage: "A payment is currently in progress. Initiating a new payment may result in duplicate transactions. Do you want to continue?"
    };
  },
  methods: {
    goBack() {
      this.$router.push("policy-details");
    },
    doUppercase() {
      this.panNumber = this.panNumber.toUpperCase().replace(/[^A-Z0-9]/g, '');
      this.userType = JSON.parse(sessionStorage.getItem("user-type"));
      const fourthChar = this.panNumber.charAt(3);
      const currentDate = new Date();
      const minDate = new Date();
      minDate.setFullYear(currentDate.getFullYear() - 18);
      const userDob = new Date(this.dateOfBirth);

      let age = this.calculateAge(this.dateOfBirth);
      console.log("user age", age)
      if(this.userType=='individual' && age<18){
        this.errorMsg["dob"] = "The Date of Birth should be above 18 years.";
        this.dateOfBirth = "";
      }else{
        this.errorMsg["dob"] = "";
      }

      if (this.userType && fourthChar === "C" && this.userType == 'corporate') {
        if (userDob > minDate) {
          this.errorMsg["pan_number"] = "For corporate PAN, the date should be at least 18 years old."
          return false;
        } else {
          this.errorMsg["pan_number"] = ""
          return false;
        }
      }
      
      // Check if 4th character is "P" - for both personal and corporate users
      if (fourthChar === "P" && this.userType == 'corporate') {
        if (this.calculateAge(this.dateOfBirth) < 18) {
          this.errorMsg["dob"] = "The Date of Establishment should be above 18 years.";
          this.handleDisableCkyc = true;
          this.isUploadDocRequired = false;
          return false;
        } else {
          this.errorMsg["dob"] = "";
          this.handleDisableCkyc = false;
          this.isUploadDocRequired = false;
          return false;
        }
      } else {
        this.errorMsg["pan_number"] = "";
        // this.errorMsg["dob"] = "";
        this.handleDisableCkyc = false;
        this.isUploadDocRequired = false;
        return false;
      }
    },
    restrictSpecialChars(event) {
      const char = String.fromCharCode(event.keyCode || event.which);
      const regex = /[A-Za-z0-9]/;
      if (!regex.test(char)) {
        event.preventDefault();
      }
    },
    onMobileInput() {
      const digits = String(this.mobileNumber ?? "").replace(/\D/g, "").slice(0, 10);
      this.mobileNumber = digits;
    },
    onOtpInput() {
      const digits = String(this.otp ?? "").replace(/\D/g, "").slice(0, 6);
      this.otp = digits;
    },
    calculateAge(dob) {
      const birthDate = new Date(dob); // expects 'YYYY-MM-DD' or valid date string
      const today = new Date();
      let age = today.getFullYear() - birthDate.getFullYear();
      const monthDiff = today.getMonth() - birthDate.getMonth();
      const dayDiff = today.getDate() - birthDate.getDate();
      if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
        age--;
      }
      return age;
    },
    fetchKyc() {
      console.log("fetchKyc called:", this.panNumber, "DOB:", this.dateOfBirth);

      this.errorMsg = {};

      const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/i;

      if (!this.fullName) {
        this.errorMsg.fullName = "Please enter full name";
        return;
      }

      if (!this.gender) {
        this.errorMsg.gender = "Please select gender";
        return;
      }

      if (!this.panNumber) {
        this.errorMsg.pan_number = "Please enter PAN card number";
        return;
      }

      if (!this.dateOfBirth) {
        this.errorMsg.dob =
          this.userType === "corporate"
            ? "Please enter date of establishment"
            : "Please enter your date of birth";
        return;
      }

      if (!panRegex.test(this.panNumber)) {
        this.errorMsg.pan_number = "Invalid PAN card number";
        return;
      }
   
      if (!this.mobileNumber) {
        this.errorMsg.mobile_number = "Please enter Mobile number";
        return;
      }
      const mobileDigits = String(this.mobileNumber).trim();
      if (!/^[6-9]\d{9}$/.test(mobileDigits)) {
        this.errorMsg.mobile_number = "Please enter a valid 10-digit mobile number";
        return;
      }
      const dob = new Date(this.dateOfBirth);
      const today = new Date();
      let age = today.getFullYear() - dob.getFullYear();

      const monthDiff = today.getMonth() - dob.getMonth();
      if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < dob.getDate())) {
        age--;
      }
      const userData = JSON.parse(sessionStorage.getItem("userData")) || {};
      userData.dateOfBirth = this.dateOfBirth;
      sessionStorage.setItem("userData", JSON.stringify(userData));

      this.getCkycDetails();
    },
    continueWithProposal() {
      this.$router.push("/process-wizard");
    },
    revisitSingleQuote() {
      this.$router.push({ path: "/policy-quote" });
    },
    //getKyc Data
    async getCkycDetails() {
      sessionStorage.setItem('fromDashboard', JSON.stringify(false));
      this.loadingState = true;
      this.loadingMsg = "Fetching CKYC Details";
      this.userData["PANNumber"] = this.panNumber;
      sessionStorage.setItem("userData", JSON.stringify(this.userData));
      this.kycRedirectUrl = "";
      this.msg = [];
      this.errorMessage = "";

      const data = {
        panNumber: this.panNumber,
        dateOfBirth: this.dateOfBirth,
      };
      sessionStorage.setItem("kycdata", JSON.stringify(data));

      let email = '';
      let mobileNumber = '';
      let proposalRefId = '';
      let aadharNumber = '';
      let gender = this.gender;
      let zipCode = '';

      if (sessionStorage.getItem("propsalDetails_review") && ['payment'].includes(this.nextRef)) {
        const proposalReviewDataFromSession = JSON.parse(sessionStorage.getItem("propsalDetails_review"));
        const proposal_response = JSON.parse(sessionStorage.getItem("proposal_response"));
        const proposerFields = proposalReviewDataFromSession?.proposal?.proposal_json?.fieldGroups?.proposerDetails?.fieldGroups?.personalDetails?.fields || {};
        email = proposerFields.email.input || '';
        aadharNumber = proposerFields.aadharNo.input || '';
        mobileNumber = proposerFields.mobileNumber.input || '';
        proposalRefId = proposal_response.ManufacturerTracking.paymentId || '';
        gender = this.gender === 'Male' ? 'M' : 'F';
        zipCode = proposalReviewDataFromSession?.proposal?.proposal_json?.fieldGroups?.proposerDetails?.fieldGroups.permanentAddressDetails.fields.zipCode.input
      } else {
        email = this.userData?.contactDetails?.emailId || '';
        mobileNumber = String(this.userData.mobileNumber) || '';
      }

      const reqData = {
        personalInformation: {
          dateOfBirth: this.dateOfBirth,
          email: "",
          mobileNumber:String(this.mobileNumber),
          zipCode: this.userData.pinCode || zipCode,
          pan: this.panNumber,
          gender: gender,
          fullName: this.fullName,
          OTP: this.otp ? String(this.otp) : "",
          aadharNumber: aadharNumber,
        },
        product: {
          insuranceCompanyCode: this.selectedPlan.insuranceAndProducts.insuranceCompanyCode,
          productId: this.selectedPlan.insuranceAndProducts.productCode,
        },
        trackInfo: {
          manufacturerQuoteID: this.singleQuote[0].trackInfo?.manufacturerQuoteID,
          manuApplicationNo: sessionStorage.getItem('applicationNumber') ? JSON.parse(sessionStorage.getItem('applicationNumber')) : this.selectedPlan.trackInfo.manufacturerQuoteID,
          KYCRequestID: "",
          proposalRefId: proposalRefId,
          referenceId: this.referenceId || "",
          manuRequirementNo: this.manuRequirementNo || "",
        },
        distributor: {
          distributorID: this.distributorID,
          agentID: this.getAgentIdFromRmData(this.rmData),
          agentType: this.rmData.RoleId =="4" ? "POSP" : "",
          salesChannel: "online",
          channelType: this.rmData.RoleId !== "1" ? "B2B" : "B2C",
        },
        kycInfo: {
          ReturnURL: "https://www.1silvebullet.tech",
        },
        journey_id: this.journey_id,
      };
      
      this.finalPayload = JSON.parse(JSON.stringify(reqData))
      const headers = { Authorization: `Bearer ${this.$store.state.token}` };

      const OVD_KYC = this.$store.state.configData?.OVD_KYC;

      try {
        console.log("calling kyc...");
        const response = await this.backendApi("getCkyc", reqData, headers);
        this.kycResponse = response?.data?.data;
        this.kycStatus = this.kycResponse?.kycInfo?.Status;
        let ckycSessionRes = {
          status: this.kycStatus
        }
        this.userData.ckycRes = ckycSessionRes;
        sessionStorage.setItem('userData', JSON.stringify(this.userData));
        this.currentKycStatus = this.kycResponse?.kycInfo?.RejectedReason;

        if (!this.referenceId) {
          this.referenceId = this.kycResponse?.trackInfo?.referenceId;
        }
        if (!this.manuRequirementNo) {
          this.manuRequirementNo = this.kycResponse?.trackInfo?.manuRequirementNo;
        }
        if (response.data.errors.length > 0) {
          this.errorMessage = `Verify that ${this.userType === 'corporate' ? 'Company' : 'your'} PAN - ${this.userType === 'corporate' ? 'Date of establishment' : 'date of birth'} combination is correct and try again. If the issue continues, please contact the support staff.`;
          this.isUploadDocRequired = true;
          sessionStorage.setItem("isUploadDocRequired", JSON.stringify(true));
          sessionStorage.removeItem("kyc_response");
          this.loadingState = false;
          this.errorMsg["dob"] = response.data.errors[0].errorDisplayMessage;
        } else if (["verifyotp"].includes(this.kycStatus?.toLowerCase())) {
          this.isUploadDocRequired = true;
          sessionStorage.setItem("kyc_response", JSON.stringify(this.kycResponse));
          this.loadingState=false;
        } else if (this.kycStatus === "approved") {
          this.loadingState=false;
          this.errorMessage = "";
          this.kycIsSucceed = true;
          setInterval(() => {
            this.timeRemain -= 1;
          }, 1000);
          sessionStorage.setItem("kyc_response", JSON.stringify(this.kycResponse));
          sessionStorage.setItem("isUploadDocRequired", JSON.stringify(false));
          this.proceedToNextPage();
        } else if (response.data.data.kycInfo.RedirectURL && OVD_KYC && OVD_KYC[this.selectedPlan.insuranceAndProducts.insuranceCompanyCode] && OVD_KYC[this.selectedPlan.insuranceAndProducts.insuranceCompanyCode] === 'REDIRECT') {
          this.loadingState = false;
          this.isUploadDocRequired = false;
          sessionStorage.setItem("isUploadDocRequired", JSON.stringify(false));
          const { KYCSTAT } = this.$store.state.configData;
          const useJourneyPolling = !!(KYCSTAT && KYCSTAT[this.selectedPlan.insuranceAndProducts.insuranceCompanyCode] === 'yes');
          this.getCkycRedirect(response.data.data.kycInfo.RedirectURL,useJourneyPolling);
        } else if (["pending", "poaincomplete", "incomplete"].includes(this.kycStatus?.toLowerCase())) {
          this.loadingState = false;
          this.isUploadDocRequired = true;
          sessionStorage.setItem("isUploadDocRequired", JSON.stringify(true));
        } else {
          this.loadingState = false;
          sessionStorage.setItem("isUploadDocRequired", JSON.stringify(true));
          this.kycRedirectUrl = this.kycResponse.kycInfo.RedirectURL;
          setTimeout(() => {
            window.open(this.kycRedirectUrl, "_blank").focus();
          }, 2000);
        }
      } catch (error) {
        console.error("Error in getCkycDetails:", error);
        this.loadingState = false;
        this.errorMessage = "An error occurred while fetching CKYC details. Please try again.";
      }
    },
    async getCkycRedirect(redirectUrl,useJourneyPolling) {
      try {
        const reqData = [this.journey_id];
        const headers = {};
        const startTime = Date.now();
        const maxDuration = 3 * 60 * 1000;
        this.loadingState = true;
        this.loadingMsg = "Fetching CKYC Details";
        var isFirstTime = true;
        while (Date.now() - startTime < maxDuration) {
          try {
            if (useJourneyPolling) {
            var response = await this.backendApi('ckycRedirect', reqData, headers, "get");
            this.loadingMsg = "Please complete kyc in new tab or refresh to stop to change the PAN details.";
            }
            else {
              var response = await this.backendApi('getCkyc', this.finalPayload, headers, "post");
            }
            if (response.data.errors && response.data.errors.length > 0) {
              if (isFirstTime) {
                isFirstTime = false;
                window.open(redirectUrl, '_blank').focus();
              }
            } else if (response.data.data.manufacturer[0].product[0].applicationStatus.manufacturerAppStatus.toLowerCase() === 'success') {
              sessionStorage.setItem("kyc_response", JSON.stringify(response.data.data));
              this.loadingState = false;
              sessionStorage.setItem("isUploadDocRequired", JSON.stringify(false));
              this.$router.push({ path: "/process-wizard" });
              break;
            }
          } catch (error) {
            this.loadingState = false;
            this.errorMessage = "An error occurred while fetching CKYC details. Please try again.";
          }
          await new Promise(resolve => setTimeout(resolve, 15000));
        }
      } catch (error) {
        this.loadingState = false;
        this.errorMessage = "An error occurred while fetching CKYC details. Please try again.";
      }
    },
    proceedToDocUpload(){
      this.$router.push('/upload-ovds?nextRef=payment');
    },
    proceedToNextPage() {
      if (this.kycMode === 'POST') {
        this.proceedToPayment();
      } else {
        this.proceedToProposal();
      }
    },
    proceedToProposal() {
      setTimeout(() => this.$router.push("process-wizard"), 2000);
    },
    async proceedToPayment() {
      const paymentDetails = sessionStorage.getItem('paymentDetails') ? JSON.parse(sessionStorage.getItem('paymentDetails')) : "";
      if (paymentDetails && paymentDetails?.payment_status?.toLowerCase() === 'success') {
        navigateToPaymentStatusOutcome(this.$router, {
          outcome: PAYMENT_STATUS_OUTCOME_SUCCESS,
          journeyId: this.journeyId || this.journey_id,
        });
      } else {
        let paymentUrl = null;
        try {
          paymentUrl = JSON.parse(sessionStorage.getItem('payment_url'));
        } catch {
          paymentUrl = null;
        }
        if (paymentUrl) {
          window.location.href = paymentUrl;
          return;
        }
        await this.paymentUrlPoll();
      }
    },
    async paymentUrlPoll(override = false) {
      this.loadingState = true;
      this.loadingMsg = "Redirecting to payment gateway...";
      try {
        const startTime = Date.now();
        const endTime = startTime + 3 * 60 * 1000; // 3 minutes timeout
        const stage = "Payment URL";
        const reqData = [this.journey_id, stage, override ? "true" : "false"];
        const headers = {};

        while (Date.now() < endTime) {
          const response = await backendApi("getPaymentUrlPoll", [], headers, "get", reqData);
          
          // Stop polling if response has errors
          if (response.data?.errors && response.data.errors.length > 0) {
            this.loadingState = false;
            console.error("Error in payment URL polling:", response.data.errors);
            return;
          }

          if (response.data.errors.length === 0) {
            // Check for nested errors in proposal_response
            if (response.data.data.proposal_response && response.data.data.proposal_response.errors && response.data.data.proposal_response.errors.length > 0) {
              this.loadingState = false;
              console.error("Error in proposal response:", response.data.data.proposal_response.errors);
              return;
            }

            // Redirect to payment URL if available
            if (response.data.data.payment_url) {
              window.location.href = response.data.data.payment_url;
              return;
            }
          }
          
          // Wait 1 second before next poll
          await new Promise(resolve => setTimeout(resolve, 1000));
        }
        
        // Timeout reached
        this.loadingState = false;
        console.error("Payment URL polling timeout");
      } catch (error) {
        this.loadingState = false;
        console.error("An error occurred during payment URL polling:", error);
      }
    },
    handlePaymentInProgressContinue() {
      // Close the dialog
      this.showPaymentInProgressModal = false;
      // Call paymentUrlPoll again with override=true
      this.loadingState = true;
      this.loadingMsg = "Redirecting to payment gateway...";
      this.paymentUrlPoll(true);
    },
    handlePaymentInProgressCancel() {
      // Close the dialog
      this.showPaymentInProgressModal = false;
      // Stop the journey, stop the API, and set loading to false
      this.loadingState = false;
      this.loadingMsg = "";
    },
  },
  watch: {
    dateOfBirth(newDate) {
      const dateParts = newDate.split("-");
      if (dateParts[0] && dateParts[0].length > 4) {
        dateParts[0] = dateParts[0].slice(0, 4);
        this.dateOfBirth = dateParts.join("-");
      }
    },
  },
  mounted() {
    this.apiReqData = JSON.parse(sessionStorage.getItem("quote_request"));
    this.distributorID = getDistributer()["distributerID"];
    this.userData = JSON.parse(sessionStorage.getItem("userData"));
    this.selectedPlan = JSON.parse(
      sessionStorage.getItem("selected_plan_data")
    );
    if (shouldSkipGodigitKycOvd(this.selectedPlan)) {
      sessionStorage.setItem("isUploadDocRequired", JSON.stringify(false));
      const nextRef = this.$route.query.nextRef || "";
      if (['payment'].includes(nextRef)) {
        const rmData = sessionStorage.getItem("rm_data")
          ? JSON.parse(sessionStorage.getItem("rm_data"))
          : null;
        const isB2C = rmData && String(rmData.RoleId) === "1";
        this.$router.replace(isB2C ? '/confirm-payment-diy' : '/confirm-payment');
      } else {
        this.$router.replace('/process-wizard');
      }
      return;
    }
    const configData = this.$store.state.configData;
    this.singleQuote = JSON.parse(sessionStorage.getItem("quoteSingleData"));
    if(this.$route.query.nextRef){
      this.nextRef = this.$route.query.nextRef || "";
    }
    // this.getCkycDetails();
    // this.setupData();
    if (sessionStorage.getItem("filledData")) {
      sessionStorage.removeItem("filledData");
    }
    sessionStorage.removeItem("kyc_response");
    this.kycIsSucceed=false;
    const isPreFilled = getDistributer()["isPreFilled"];
    if (this.$store.state.customerData && isPreFilled) {
      const customerData = this.$store.state.customerData;
      this.panNumber = customerData.kycDetails.panNumber;
      this.dateOfBirth = customerData.personalInformation.dateOfBirth;
    }
    this.userType = JSON.parse(sessionStorage.getItem("user-type"));
    this.kycStatus = this.userData?.ckycRes != undefined && this.userData?.ckycRes.status ? this.userData.ckycRes.status : "";
    if(this.userData && this.userData.regNumber){
      delete this.userData.regNumber;
    }
    sessionStorage.setItem("userData", JSON.stringify(this.userData));
    let kycData = JSON.parse(sessionStorage.getItem("kycdata"));
    if (kycData) {
      this.panNumber = kycData.panNumber ? kycData.panNumber : "";
      this.dateOfBirth = kycData.dateOfBirth ? kycData.dateOfBirth : "";
    }
    if (sessionStorage.getItem("rm_data")) {
      this.rmData = JSON.parse(sessionStorage.getItem("rm_data"));
    }
    const OVD_KYC = this.$store.state.configData?.OVD_KYC;
    if (
      !shouldSkipGodigitKycOvd(this.selectedPlan) &&
      OVD_KYC &&
      OVD_KYC[this.selectedPlan.insuranceAndProducts.insuranceCompanyCode] &&
      OVD_KYC[this.selectedPlan.insuranceAndProducts.insuranceCompanyCode] !== 'SKIP'
    ) {
      this.isOvd = true;
    } else {
      this.isOvd = false;
    }

    const propsalDetails_review = JSON.parse(sessionStorage.getItem("propsalDetails_review"));
    if (propsalDetails_review && ['payment'].includes(this.nextRef)) {
      const { fullName = '', PAN = '', dateOfBirth = '', gender = '', mobileNumber = '' } = propsalDetails_review.proposal.proposal_json.fieldGroups.proposerDetails.fieldGroups.personalDetails.fields;
      this.fullName = fullName.input;
      this.dateOfBirth = dateOfBirth.input;
      this.panNumber = PAN.input;
      this.gender = gender.input.toLowerCase() =="male" ? "M" : "F";
      this.mobileNumber = mobileNumber.input || '';
    } else {
      this.mobileNumber = String(this.userData?.mobileNumber || '');
    }
    this.onMobileInput();

    const kycMode = this.$store.state.configData["KYCMODE"];
    this.kycMode = kycMode[this.selectedPlan['insuranceAndProducts']['productCode']];
    if (!this.kycMode) {
      this.kycMode = kycMode[this.selectedPlan['insuranceAndProducts']['insuranceCompanyCode']];
    }
  },
  computed: {
    getMaxDate() {
      const today = moment();
      if (this.userType === 'corporate') {
        return today.subtract(1, 'day').format('YYYY-MM-DD');
      } else {
        return today.subtract(18, 'years').format('YYYY-MM-DD');
      }
    },
    isShow() {
      return sessionStorage.getItem('fromDashboard') ? JSON.parse(sessionStorage.getItem('fromDashboard')) : false;
    },
    changeInCkycFields() {
      let oldCKYC = JSON.parse(sessionStorage.getItem("kycdata"));
      if(this.panNumber != oldCKYC.panNumber || this.dateOfBirth != oldCKYC.dateOfBirth){
        return false;
      }
      return true
    },
    getSuccessMessage(){
      if(['POST'].includes(this.kycMode)){
        return this.currentKycStatus;
      }
      return "Please proceed with the proposal and upload the required KYC documents."
    }
  },
};
</script>
<style scoped lang="scss">
@import "../../assets/scss/components/process-wizard.scss";
@import "../../assets/scss/components/Kyc.scss";

.successClass {
  font-size: 14px;
  color: #07b154;
  line-height: 155%;
  margin-top: 0.8rem;
  text-align: left;

  a {
    color: #3b39d9;
    padding-bottom: 0.1rem;
    cursor: pointer;
    border-bottom: 1px solid #3b39d9;
  }
}
.success_ckyc_msg{
  font-size: 14px;
  color: #07b154;
  line-height: 155%;
  text-align: left;
}

.backbuttonTop {
  display: flex;
  gap: 6px;
  text-align: left;
  font-size: 16px !important;
  padding: 0 !important;
  max-width: 200px;
  background-color: transparent;
  border: none;
  color: $main-bg;
  font-size: 12px !important;
}

.custom-list {
  text-align: left !important;
  list-style-type: disc;
  // margin-left: 20px;
  margin-top: 20px;
  font-size: 14px;
  line-height: 144%;
}
.custom-list li {
  margin-bottom: 10px;
}

.continueWithProposal {
  font-size: 14px;
  padding-block: 10px;
  background-color: $main-bg;
  color: $commonColor;
  width: 500px;
  &:hover{
    border:1px solid $main-bg;
  }
}

.mr-10 {
  margin-right: 10px;
}

.dark {
  .data-placeholder{
    color: white;
  }
  .custom-list{
    color: $base-dark-text;
  }
}
</style>
